import { ApolloClient, gql } from 'apollo-boost';
import { FeedbackSectionId } from 'donor/portal/pages/FeedbackDashboard/Feedback/utils';

const mutation = gql`
  mutation DeleteNpoAnswer($id: Int!) {
    deleteNpoAnswer(id: $id) {
      success
    }
  }
`;

export const deleteReportAnswer = (
  client: ApolloClient<object>,
  answerId: number | string,
  reportId: number | string,
  sectionId: FeedbackSectionId,
) => {
  return client.mutate<{ deleteNpoAnswer: { success: boolean } }>({
    mutation: mutation,
    variables: {
      reportId,
      sectionId,
      id: answerId,
    },
    fetchPolicy: 'no-cache',
  });
};

export const deleteReportAnswers = (
  client: ApolloClient<object>,
  answerIds: (number | string)[],
  reportId: number | string,
  sectionId: FeedbackSectionId,
) => {
  return Promise.all(
    answerIds.map(
      async answerId =>
        await deleteReportAnswer(client, answerId, reportId, sectionId),
    ),
  );
};
